import { useEffect, useState } from 'react';

import useThrottle from 'src/hooks/useThrottle';

export default function useScrollEnd(throttleTime = 100) {
  const [direction, setDirection] = useState({
    isTop: true,
    isBottom: false,
  });

  const handleScroll = useThrottle(() => {
    setDirection({
      isBottom: window.pageYOffset === document.body.clientHeight,
      isTop: window.pageYOffset === 0,
    });
  }, throttleTime);

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return direction;
}
